import React from 'react';
import { Box, TextField } from '@material-ui/core';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import {
  formatIsoDateInput,
  getExpiresDateRangeValue,
  parseIsoDateString,
} from './expiresDateUtils';

export function ExpiresDateRangeFilterInput({
  item,
  applyValue,
  focusElementRef,
  disabled,
}: GridFilterInputValueProps) {
  const [from, to] = getExpiresDateRangeValue(item.value);

  const handleFromChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    applyValue({
      ...item,
      value: [parseIsoDateString(event.target.value), to],
    });
  };

  const handleToChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    applyValue({
      ...item,
      value: [from, parseIsoDateString(event.target.value)],
    });
  };

  return (
    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
      <TextField
        inputRef={focusElementRef}
        label="From"
        type="date"
        variant="outlined"
        size="small"
        value={formatIsoDateInput(from)}
        onChange={handleFromChange}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="To"
        type="date"
        variant="outlined"
        size="small"
        value={formatIsoDateInput(to)}
        onChange={handleToChange}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
}
